import axios from 'axios'

async function start_train_test(data,token,setOpen,setMessage,setSubmitting,setHasStarted,setQuestion,setIsPaused,setDiv,setTime,setHistory){

    setSubmitting(true)

    const URL = `${process.env.REACT_APP_SERVER_AUTH_URL}start-train-test/`

      const testStart = await axios.post(URL,data,{
           headers:{
                  "Content-Type":"application/json", 
                  "Authorization":`Bear ${token}`
              }
       }).catch(err=>{
        console.log(err)
      })

      if (testStart?.status == 200 && testStart?.data.success) {

        setSubmitting(false)
        setQuestion(testStart?.data.question)
        setHistory(testStart?.data.history)
        setHasStarted(true)
        setIsPaused(false)
        setTime(data?.test.time*60)
        setDiv((data?.test.time*60)/data?.test.questions) 

      }else{
        setSubmitting(false)
        setHasStarted(false)
        setMessage(testStart?.data?.message)
        setOpen(true)
      }
}

export default start_train_test